import { useEffect, useRef, useState } from 'react';
export const useElementSize = () => {
    const elementRef = useRef(null);
    const [size, setSize] = useState({ width: 0, height: 0 });
    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            const { width, height } = entries[0].contentRect;
            const newSize = { width, height };
            setSize(newSize);
        });
        if (elementRef.current) {
            resizeObserver.observe(elementRef.current);
        }
        return () => resizeObserver.disconnect();
    }, []);
    return Object.assign({ ref: elementRef }, size);
};
